module.exports = __webpack_public_path__ + "img/default-mark.b8bffb57.svg";